import { useGetManagedEmployerQuery } from "../get-managed-employer";

export const useCanSetupATSIntegration = () => {
  const { data: employerProfile, isLoading } = useGetManagedEmployerQuery();
  const canSetupATSIntegration = !!employerProfile?.can_setup_ats_integration;

  return { canSetupATSIntegration, isLoading };
};
